import axios from "axios";
import { post, put, get, del } from '../api/axioshHttp'


// 获取小区列表
export const getcommunityList = params => {
    return get("/admin/xiaoqus", params);
};
// 获取小区选择活动
export const getcommunityAct = params => {
    return get("admin/xiaoqus/getActivity", params);
};
// 新增小区
export const addcommunity = params => {
    return post("/admin/xiaoqus", params);
};
// 修改小区信息
export const editcommunity = params => {
    return put(`/admin/xiaoqus/${params.id}`, params);
};
// 删除小区
export const deletecommunity = params => {
    return del(`/admin/xiaoqus/${params}`);
};
// 生成小程序码
export const getappImgs = params => {
    return post("/admin/xiaoqus/qrcode", params);
};
// 生成短码
export const getShort = params => {
    return post("/admin/xiaoqus/shortStr", params);
};
// 生成短链
export const getShortUrl = params => {
    return post("/admin/xiaoqus/shortUrl", params);
};
// 发送短信
export const sellMsg = params => {
    return post(`/admin/xiaoqus/sms/${params.id}`);
};
// 选择公司
export const getShowCompany = params => {
    return get(`/admin/xiaoqus/showCompany`, params);
};
// 查询销售
export const getXsList = params => {
	return post("/admin/xiaoqus/bindStaffQuery", params);
};
// 获取小区租期配置
export const getRentTenancy = xiaoquId => {
    return get(`/admin/xiaoqus/xqRentTenancy/${xiaoquId}`);
};
// 获取客户评分规则版本列表
export const getCustomerVersionList = params => {
	return get(`/admin/ruleEngine/userScore/ruleEngineVersions`, params);
}



// WEBPACK FOOTER //
// ./src/api/community.js